export default "__VITE_ASSET__CcWJ20ss__"